import { useCallback, useEffect, useState } from 'react';
import type { OrderSettlementReadinessDto } from '../../dto/orderSettlement';
import { fetchOrderSettlementReadiness } from './api/orderSettlementApi';

export function useOrderSettlementReadiness(orderId: string | undefined, enabled: boolean) {
  const [readiness, setReadiness] = useState<OrderSettlementReadinessDto | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const refresh = useCallback(async () => {
    if (!orderId || !enabled) { setReadiness(null); setError(false); return; }
    setLoading(true);
    setError(false);
    try { setReadiness(await fetchOrderSettlementReadiness(orderId)); }
    catch (requestError: any) {
      setReadiness(null);
      if (requestError?.response?.status !== 403 && requestError?.response?.status !== 404) setError(true);
    }
    finally { setLoading(false); }
  }, [enabled, orderId]);
  useEffect(() => { void refresh(); }, [refresh]);
  return { readiness, loading, error, refresh };
}
